// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__K1Lr9","social":"socials__social__o9Js7","icon":"socials__icon__rqonR","navOpen":"socials__navOpen__JrQEe"};